module.exports = __webpack_public_path__ + "static/media/domes.41492bb7.png";